import { PagedRow } from "../../home/models/PageTypes";
import { InvoiceStatus, PackageType, PaymentRequirement } from "../../invoices/models/InvoiceModel";
import { Region } from "../../products/models/WarehouseModel";
import { AppliedPaymentModel } from "../../payments/models/PaymentModels";
import { PhoneModel } from "../../home/models/ContactInfo";
import { AddressModel } from "../../customers/models/AddressModel";

export enum OrderStatus {
    all = 0,
    pending = 1,
    approved = 2,
    canceled = 3,
    declined = 4,
    completed = 5,
    closed = 6
}

export enum OrderRejectReason {
    none = 0,
    changeMind = 1,
    damaged = 2,
    outOfStock = 3,
    priceTooHigh = 4,
    waitTooLong = 5
}

export enum OrderTracking {
    none = 0,
    placedOnline = 1,
    inForeignStock = 2,
    shippedToDestination = 3,
    arrivedDestination = 4,
    readyForDelivery = 5,
    outForDelivery = 6,
    delivered = 7
}

export enum TrackingStatus {
    inCompleted = 0,
    inProgress = 1,
    completed = 2
}

export enum OrderRequestType {
    all = 0,
    immediate = 1,
    scheduled = 2,
    waitForOthers = 3,
    checkMoreItems = 4,
    preOrder = 5
}

export interface OrderTrackingInfo {
    order: string;
    key: string;
    name: string;
    status: TrackingStatus;
}

//export interface NewOrderModel {
//    customerId: number;
//    customer: string;
//    link: string;
//    qty: number;
//    note: string;
//}

//export const createNewOrder = (): NewOrderModel => ({
//    customerId: 0,
//    customer: "",
//    link: "",
//    qty: 0,
//    note: ""
//});

//export interface ApproveOrderModel {
//    id: number;
//    status: OrderStatus;
//    reason?: OrderRejectReason;
//    tracking?: OrderTracking;
//    note?: string;
//}

//export interface EditOrderModel {
//    id: number;
//    price: number;
//    qty: number;
//    rate: number;
//    domesticShipping: number;
//    chargeWeight: number;
//    shippingRate: number;
//    note?: string;
//    trackingNo?: string;
//}

//export const createEditOrder = (): EditOrderModel => ({
//    id: 0,
//    price: 0,
//    qty: 0,
//    rate: 0,
//    domesticShipping: 0,
//    chargeWeight: 0,
//    shippingRate: 0,
//    note: ""
//});

export interface BasicSubmitOrderModel {
    cartId: number;
    addressId?: number;
    phoneId?: number;
    payments: AppliedPaymentModel[];
}

export interface SubmitOrderModel extends BasicSubmitOrderModel {
    currentUserCustomerId: number;
    customerId: number;
    requestType: OrderRequestType;
    requestDate: Date;
    note: string;
    shipping: number;
    approvedOrders: boolean;
    generateInvoice: boolean;
    packageType: PackageType;
    deliveryMethod: string;
    paymentRequirement: PaymentRequirement;
    consolidated: boolean;
    customerPayShipping: boolean;
    freeShipping: boolean;
}

export const createSubmitOrderModel = (): SubmitOrderModel => ({
    currentUserCustomerId: 0,
    customerId: 0,
    cartId: 0,
    addressId: undefined,
    phoneId: undefined,
    payments: [],
    requestType: OrderRequestType.immediate,
    requestDate: new Date(0),
    note: "",
    shipping: 0,
    approvedOrders: false,
    generateInvoice: false,
    packageType: PackageType.box,
    deliveryMethod: "",
    paymentRequirement: PaymentRequirement.beforeDelivery,
    consolidated: false,
    customerPayShipping: false,
    freeShipping: false
});

export interface ShortOrderItemModel {
    id: number;
    orderId: string;
    status: OrderStatus;
    invoiceId?: string;
    invoiceStatus?: InvoiceStatus;
    price: number;
    cost: number;
    confirmedWithCustomer: boolean;
    profitPercent: number;
    profitWarned: boolean;
    qty: number;
    reason?: OrderRejectReason;
    tracking?: OrderTracking;
    earningPointRate: number;
    isOpen: boolean;
    orderDate: Date;
    customerId: number;
    customer: string;
    fromWarehouseId: number;
    fromWarehouse: string;
    region?: Region;
    addressId?: number;
    phoneId?: number;
    note?: string;
    costConfirmed: boolean;
    requestType: OrderRequestType;
    requestDate: Date;
    freeShipping: boolean;

    productId: number;
    barcode: string;
    size: string;
    code: string;
    lineId: number;
    lineName: string;
    style: string;
    pictureTag: string;
    groupId: number;
    productName: string;
    brandId: number;
    brand: string;
    categoryIds: string;

    trackings: OrderTrackingInfo[];
    imageUrl: string;
}

export const createShortOrderItemModel = (): ShortOrderItemModel => ({
    id: 0,
    orderId: "",
    status: OrderStatus.all,
    invoiceId: undefined,
    invoiceStatus: undefined,
    price: 0,
    cost: 0,
    confirmedWithCustomer: false,
    profitPercent: 0,
    profitWarned: false,
    qty: 0,
    reason: undefined,
    tracking: undefined,
    earningPointRate: 0,
    isOpen: false,
    orderDate: new Date(0),
    customerId: 0,
    customer: "",
    fromWarehouseId: 0,
    fromWarehouse: "",
    region: undefined,
    addressId: undefined,
    phoneId: undefined,
    note: "",
    costConfirmed: false,
    requestType: OrderRequestType.immediate,
    requestDate: new Date(0),
    freeShipping: false,

    productId: 0,
    barcode: "",
    size: "",
    code: "",
    lineId: 0,
    lineName: "",
    style: "",
    pictureTag: "",
    groupId: 0,
    productName: "",
    brandId: 0,
    brand: "",
    categoryIds: "",

    trackings: [],
    imageUrl: ""
});

export interface OrderModel extends PagedRow {
    customerId: number;
    customer: string;
    id: string;
    date: Date;
    service: number;
    shipping: number;
    items: ShortOrderItemModel[];
}

export const createOrderModel = (): OrderModel => ({
    customerId: 0,
    customer: "",
    id: "",
    date: new Date(0),
    service: 0,
    shipping: 0,
    items: []
});

//export interface OrderFilterModel extends IPageFilterModel {
//    customerId: number;
//    customer?: string;
//    isAllWarehouses: boolean;
//    isOpen: boolean;
//    isUnInvoiced: boolean;
//    warehouseId: number;
//    status: OrderStatus;
//    reason: OrderRejectReason;
//    tracking: OrderTracking;
//    requestType: OrderRequestType;
//}

//export interface ChangeWebsiteOrderModel {
//    id: number;
//    websiteId?: number;
//    earningPointRate: number;
//}

export interface CheckoutSummaryModel {
    count: number;
    amount: number;
    shipping: number;
    total: number;
    payments: AppliedPaymentModel[];
    totalPaid: number;
    balance: number;
    earningPoints: number;
    address?: AddressModel;
    phone?: PhoneModel;
}

export interface OrderConfirmModel {
    id: string;
    total: number;
    date: Date;
    earningPoints: number;
}